import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import ModalCadastrarSistema from '../../components/modal/ModalCadastrarSistema'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalEditarSistema from '../../components/modal/ModalEditarSistema';
import ModalExcluirSistema from '../../components/modal/ModalExcluirSistema';
import moment from 'moment/moment';
import Tabela from '../../components/Tabela';

function Sistema() {
    const { Success, Error, openModal, setOpenModal, SistemasConsulta, ListaSistemasConsulta, loading, modalEditarSistema, setModalEditarSistema, setEdicaoSistema, setSistemaAtualKey, modalExcluirSistema, setModalExcluirSistema, Permissao, ListaFiltroSistema, totalRegistrosSistema, filtroSistema, totalRegistrosFiltroSistema } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");


    const EditSistema = (props) => {
        setModalEditarSistema(true)
        setSistemaAtualKey(props.key)
        setEdicaoSistema(props)
    }

    const DeletarSistema = (props) => {
        setSistemaAtualKey(props.key)
        setModalExcluirSistema(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroSistema(searchTerm, currentPage, pageSize);
        } else {
            ListaSistemasConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroSistema : totalRegistrosSistema;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar sistema'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarSistema &&
                <ModalEditarSistema currentPage={currentPage} />
            }
            {modalExcluirSistema &&
                <ModalExcluirSistema />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarSistema closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar sistema</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Sistemas cadastrados</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroSistema : SistemasConsulta}
                            columns={[
                                { label: "Sistema", field: "nome", width: "40%", render: (x) => x.nome || "-" },
                                { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditSistema(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarSistema(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroSistema(term, 1, 10);
                                } else {
                                    ListaSistemasConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Sistema;